import _difference from 'lodash/difference';

import { GOOGLE_APP } from '../constants/oAuthScopes';

export function hasGoogleAppScopes(currentScopes = null) {
  return currentScopes && _difference(GOOGLE_APP, currentScopes).length === 0;
}
